/** "Sun, Jun 28" in the given locale. iso may be a full ISO timestamp. */
export function formatServiceDate(iso: string, locale: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return new Intl.DateTimeFormat(locale, { weekday: 'short', day: 'numeric', month: 'short' }).format(d);
}

/** "Jun 28" (no weekday) — compact form for song/version dates. */
export function formatShortDate(iso: string, locale: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'short' }).format(d);
}

export type RelHint = { key: string; n?: number } | null;

/** Relative hint for dates within ±7 days; null otherwise. Date-only diff. */
export function relativeHint(iso: string, today: Date): RelHint {
  const a = new Date(iso); if (Number.isNaN(a.getTime())) return null;
  const dayMs = 86400000;
  const ymd = (x: Date) => Date.UTC(x.getUTCFullYear(), x.getUTCMonth(), x.getUTCDate());
  const diff = Math.round((ymd(a) - ymd(today)) / dayMs);
  if (diff === 0) return { key: 'library.relToday' };
  if (diff === 1) return { key: 'library.relTomorrow' };
  if (diff === -1) return { key: 'library.relYesterday' };
  if (diff >= 2 && diff <= 7) return { key: 'library.relInDays', n: diff };
  if (diff <= -2 && diff >= -7) return { key: 'library.relDaysAgo', n: -diff };
  return null;
}

/**
 * Когда кэш последний раз обновлялся — для строки свежести.
 *
 * Две формы, потому что вопрос у человека разный. В пределах недели он звучит
 * «это с прошлой репетиции или с сегодняшней?» — отвечают день недели и время.
 * Старше недели время уже не помогает, а место занимает: остаётся дата.
 */
export function formatFreshWhen(iso: string, locale: string, nowMs: number): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const weekMs = 7 * 86400000;
  if (nowMs - d.getTime() < weekMs) {
    return new Intl.DateTimeFormat(locale, {
      weekday: 'short', hour: '2-digit', minute: '2-digit',
    }).format(d);
  }
  return formatShortDate(iso, locale);
}
